var R={NEED_PASSWORD:1,INCORRECT_PASSWORD:2};export{R as default};
//# sourceMappingURL=PasswordResponses.js.map
